// messaging.service.ts
import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { BehaviorSubject } from 'rxjs';
import firebase from "firebase/compat/app";
import MessagePayload = firebase.messaging.MessagePayload;
import {SchoolService} from "./school.service";

@Injectable({ providedIn: 'root' })
export class MessagingService {
    currentMessage = new BehaviorSubject<MessagePayload | null>(null);

    constructor(private afMessaging: AngularFireMessaging, private schoolService: SchoolService) {
        this.afMessaging.messages.subscribe(msg => this.currentMessage.next(msg));
    }

    requestPermission() {
        this.afMessaging.requestToken
            .subscribe(
                (token) => {
                    console.log('Permission granted! Token:', token);
                    if (token) {
                        localStorage.setItem('token', token);
                    }
                },
                (error) => {
                    console.error('Permission denied', error);
                }
            );
    }
}
